/**
 * Remembers across the reload after a logout where the person was and whether the session had expired,
 * so the login can show a hint and lead back to that page. Only this tab (sessionStorage), storage is optional.
 */
const RETURN_KEY = 'vanilla.login.returnTo';
const EXPIRED_KEY = 'vanilla.login.sessionExpired';

/** Pages that make no sense after the login (guest pages, the login itself) */
const NO_RETURN = [/^\/login(\/|\?|$)/, /^\/signup\//, /^\/(onboarding|forgot-password|signup-complete|logged-out)(\/|\?|$)/];

export function isReturnPath(path: unknown): path is string {
    return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//') && !NO_RETURN.some((el) => el.test(path));
}

function read(key: string): string | null {
    try {
        return sessionStorage.getItem(key);
    } catch (e) {
        return null;
    }
}

function write(key: string, value: string | null) {
    try {
        if (value === null) {
            sessionStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, value);
        }
    } catch (e) {
        // storage is optional
    }
}

/** Automatic logout (session expired): hint on the login and back to the page afterwards */
export function rememberExpiredSession(fullPath: string | undefined) {
    write(EXPIRED_KEY, '1');
    write(RETURN_KEY, isReturnPath(fullPath) ? fullPath : null);
}

/** Own logout: nothing to show and nowhere to return to */
export function forgetSessionEnd() {
    write(EXPIRED_KEY, null);
    write(RETURN_KEY, null);
}

/** Read once on the login page */
export function takeSessionExpired(): boolean {
    const expired = read(EXPIRED_KEY) === '1';
    write(EXPIRED_KEY, null);
    return expired;
}

/** Read once after a successful login */
export function takeReturnPath(): string | undefined {
    const path = read(RETURN_KEY);
    write(RETURN_KEY, null);
    return isReturnPath(path) ? path : undefined;
}
